import { Box, Stack } from '@mui/material';

import { SkeletonBox } from '../_user-tab/styled';

export const ChartCardSkeleton = () => {
  return (
    <Box
      p="16px"
      width="100%"
      bgcolor="#191D26"
      borderRadius="16px"
      sx={{ boxShadow: '0 10px 26px rgba(0,0,0,0.35)' }}
    >
      <Stack gap="12px" flexDirection="column">
        <SkeletonBox animation="wave" height={23} width={148} />
        <SkeletonBox animation="wave" height={23} width={148} />
      </Stack>

      <Box mt="18px" display="grid" gridTemplateColumns="30px 1fr" columnGap="12px">
        <Stack flexDirection="column" justifyContent="space-between" height={181} pb="6px">
          {Array.from({ length: 5 }).map((_, i) => (
            <SkeletonBox
              key={i}
              animation="wave"
              height={10}
              width={26}
              sx={{ borderRadius: '6px', opacity: 0.55 }}
            />
          ))}
        </Stack>

        <SkeletonBox animation="wave" height={181} sx={{ borderRadius: '12px' }} />
      </Box>

      <Box mt="10px" ml="56px" display="flex" justifyContent="space-between">
        {Array.from({ length: 7 }).map((_, i) => (
          <SkeletonBox
            key={i}
            animation="wave"
            height={10}
            width={34}
            sx={{ borderRadius: '6px', opacity: 0.55 }}
          />
        ))}
      </Box>
    </Box>
  );
};
